import DataTable from 'examples/Tables/DataTable'
import React from 'react'

function AptaTable({ columns, columnsModify = false, rows }) {
    return (
        <div>
            <DataTable
                table={{
                    columns:
                        columnsModify ? columns :
                            columns?.map(item => ({ Header: item, accessor: item }))
                    , rows
                }}

                isSorted={false}
            // entriesPerPage={false}
            // showTotalEntries={false}
            // noEndBorder={false}
            />
        </div>
    )
}

export default AptaTable